import get from 'lodash/object/get'

const extractErrorMessage = (value: unknown): string =>
  get(value, 'data.error.message')
  || get(value, 'error.message')
  || get(value, 'message')

export default extractErrorMessage
